import { ServicesURL } from "@utils/utilsApi";
import { PERMISSIONS } from "@utils/permissions";
import { DynamicFilterValue } from "@components/DynamicFilterCst/types";

export type UGTabKey = "users" | "static-groups" | "dynamic-groups";

export type UGEntityType = "user" | "group-static" | "group-dynamic";

export const UG_TABS: UGTabKey[] = ["users", "static-groups", "dynamic-groups"];

// Permesso di lettura richiesto per vedere ciascun tab.
export const UG_TAB_PERMISSION: Record<UGTabKey, string> = {
  users: PERMISSIONS.users.read,
  "static-groups": PERMISSIONS.groups.static.read,
  "dynamic-groups": PERMISSIONS.groups.dynamic.read,
};

export const UG_TAB_TO_ENTITY: Record<UGTabKey, UGEntityType> = {
  users: "user",
  "static-groups": "group-static",
  "dynamic-groups": "group-dynamic",
};

export const isGroupTab = (tab: UGTabKey): boolean =>
  tab === "static-groups" || tab === "dynamic-groups";

export const buildUGListUrl = (
  tab: UGTabKey,
  corporateId: string,
): string | null => {
  if (!corporateId) return null;
  switch (tab) {
    case "users":
      return `${ServicesURL.getCustomer}?corporate_id=${corporateId}`;
    case "static-groups":
      return `${ServicesURL.staticGroups}/static?id_corporate=${corporateId}`;
    case "dynamic-groups":
      return ServicesURL.dynamicGroups.replace(":idCorporate", corporateId);
    default:
      return null;
  }
};

export type FieldValue = DynamicFilterValue;

export interface UGTabFilters {
  search?: string;
  fieldFilters?: Record<string, FieldValue>;
  sort?: string | null;
  page?: number;
}

export interface UGMeta {
  activeTab?: UGTabKey;
}

export const LO_SECTION_ANCHOR = "learning-objects";

// Header fisso dell'app piu' il blocco sticky della pagina e un margine di
// respiro, cosi' il titolo della sezione non finisce coperto sull'ancora.
export const SECTION_ANCHOR_SCROLL_MARGIN =
  "calc(var(--app-header-height, 180px) + var(--v2-page-header-height, 0px) + 16px)";
